export default function Faq() {
  const faqs = [
    {
      question: 'What classes are available at Tiny Wings Preschool?',
      answer: 'Tiny Wings Preschool offers Playgroup, Nursery, Junior KG and Senior KG.'
    },
    {
      question: 'Where is Tiny Wings Preschool located?',
      answer: 'Tiny Wings Preschool is located near Datta Mandir and Mayur Park in Chhatrapati Sambhaji Nagar, Maharashtra.'
    },
    {
      question: 'What learning approach does Tiny Wings Preschool follow?',
      answer: 'Tiny Wings Preschool focuses on activity-based learning, phonics, age-appropriate activities, early language development, creativity and school readiness.'
    },
    {
      question: 'How can parents enquire about admission?',
      answer: 'Parents can contact Tiny Wings Preschool through the contact details provided on the website and enquire about available admissions.'
    },
    {
      question: 'Does Tiny Wings Preschool provide Playgroup and Nursery?',
      answer: 'Yes. Playgroup and Nursery are among the programs offered by Tiny Wings Preschool.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50 dark:from-gray-800 dark:via-gray-900 dark:to-gray-800 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Learn more about our programs, location and admissions process.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="bg-white dark:bg-gray-800 rounded-2xl p-5 shadow-lg" open={index === 0}>
              <summary className="cursor-pointer font-semibold text-lg text-gray-900 dark:text-white list-none">
                {faq.question}
              </summary>
              <p className="mt-4 text-gray-600 dark:text-gray-300 leading-relaxed">
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
